import React from "react";
import { Dropdown } from "react-bootstrap";
import Navigation from "../nav/nav";
import Globals from "../../api";

export default class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      headerData: [],
      language: {},
      languages: [],
      electionSettingsData: [],
      isSidebarOpen: false,
    };
  }

  // ✅ API Calls
  getLanguage() {
    fetch(Globals.language_based_api)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          language: data.Contents[0].Language,
          languages: data.Contents[0].Languages,
        });
      });
  }

  componentDidMount() {
    fetch(Globals.Desktop_header_based_api)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          headerData: data.NavigationMenu.Items,
        });
      });

    this.getLanguage();
  }

  // ✅ Toggle Sidebar
  toggleSidebar = () => {
    this.setState(
      (prev) => ({ isSidebarOpen: !prev.isSidebarOpen }),
      () => {
        document.body.classList.toggle(
          "opensidebar",
          this.state.isSidebarOpen
        );
      }
    );
  };

  render() {
    let { headerData, language, languages, isSidebarOpen } = this.state;

    // 📅 Date
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const today = new Date();

    // 🌐 Language List
    const LangNames = languages.map((item, i) => (
      <li key={i} className={item.Code}>
        <a
          className={language?.Name === item.Name ? "active" : ""}
          href={item.Site}
          title={item.Name}
        >
          {item.Name}
        </a>
      </li>
    ));

    // 📌 Navigation Menu
    const NavMenu = headerData.map((item, i) => (
      <ul className="dropdown_menslink" key={i}>
        <h3>
          <a href={item.DefaultUrl}>{item.Text}</a>
        </h3>
        {item.Items.map((sub, j) => (
          <li key={j}>
            <a href={sub.DefaultUrl}>{sub.Text}</a>
          </li>
        ))}
      </ul>
    ));

    return (
      <>
        {/* 🔥 HEADER */}
        <div className="header_section">

          {/* TOP BAR */}
          <div className="h_top_sect">
            <div className="container">
              <div className="h_top_block">

                <div className="wd_date">
                  {today.toLocaleDateString(
                    Globals.LanguageCode + "-IN",
                    options
                  )}
                </div>

                <div className="wd_lang">
                  <ul>
                    <li><span>Choose your language</span></li>
                    {LangNames}
                  </ul>
                </div>

                <div className="h_top_rightsect">
                <ul className="wd_social_link">
                  <li><span>Follow us</span></li>
                  <li class="fb_icon"><a title="facebook" alt="facebook" href="https://www.facebook.com/pages/Webdunia-Malayalam/189868854377429" target="_blank"></a></li>
                  <li class="tw_icon"><a title="twitter" alt="twitter"  href="https://x.com/wdmalayalamwd" target="_blank"></a></li>
                  <li class="int_icon"><a title="instagram" alt="instagram" href="https://www.instagram.com/webdunia.malayalam"  target="_blank"></a></li>
                  <li class="yout_icon"><a title="youtube" alt="youtube"   href="https://www.youtube.com/@Webdunia-Malayalam"  target="_blank"></a></li>     
                 </ul>
                </div>

              </div>
            </div>
          </div>

          {/* MAIN HEADER */}
          <div className="header_sect">
            <div className="container">

              {/* LEFT */}
              <div className="h_left_col">
                <div className="m_bar">
                  <Dropdown>
                    <Dropdown.Toggle onClick={this.toggleSidebar}>
                      <div className="menu_hambur"><span className="m_hamb1"></span><span className="m_hamb2"></span><span
                        className="m_hamb3"></span></div>
                    </Dropdown.Toggle>
                  </Dropdown>
                </div>

                <div className="wd_logo">
                  <a href="/">
                    <img
                      width="125"
                      height="65"
                      alt="logo"
                      src={require("../../assets/img/logo/ml-logo.svg").default}
                    />
                  </a>
                </div>
              </div>

              {/* CENTER */}
              <div className="h_mid_col">
                <Navigation />
              </div>

              {/* RIGHT */}
              <div className="h_right_col">
                <div className="h_search_apps">
                  <div class="m_wd_date"> {today.toLocaleDateString(
                     + "en-IN",
                    options
                  )}</div>
                <ul>
                  <li><a title="Play store" alt="Play store"
                href="https://play.google.com/store/apps/details?id=com.webdunia.app&amp;hl=en" className="playstore_icon"
                target="_blank"></a></li>
                </ul>
              </div>
              </div>
            </div>
          </div>
        </div>

    {/* 🔥 SIDEBAR */}
<div className={`wd_sidebar_wrapper ${isSidebarOpen ? "open" : ""}`}>
  
  <div className="wd_sidebar_head">
    <span className="m_wd_logo">
      <a href="/">
        <img src="/assets/img/logo/ml-logo.svg" alt="webdunia" width="90" height="47" />
      </a>
    </span>

    <span className="wd_close_col">
      <button aria-label="Close side menu" id="close_sidemenu" onClick={this.toggleSidebar}>
        <img src="/assets/img/close-icon.svg" alt="webdunia" />
      </button>
    </span>
  </div>

  <div className="wd_sidebar_body">
    <div className="wd_sidebar_menus" id="tree">
      
      <ul>
        <li>
          <span className="choose_lang active">Choose your language</span>
          <ul>
            <li className="hi"><a href="https://hindi.webdunia.com" title="हिन्दी" languagecode="hi">हिन्दी</a>  </li>
            <li className="en"><a href="https://english.webdunia.com" title="English" languagecode="en">English</a> </li>
            <li className="ta"><a href="https://tamil.webdunia.com" title="தமிழ்" languagecode="ta">தமிழ்</a> </li>
            <li className="mr"><a href="https://marathi.webdunia.com" title="मराठी" languagecode="mr">मराठी</a></li>
            <li className="te"><a href="https://telugu.webdunia.com" title="తెలుగు" languagecode="te">తెలుగు</a> </li>
            <li className="ml"><a className="active" href="https://malayalam.webdunia.com" title="മലയാളം" languagecode="ml">മലയാളം</a></li>
            <li className="kn"><a href="https://kannada.webdunia.com" title="ಕನ್ನಡ" languagecode="kn">ಕನ್ನಡ</a></li>
            <li className="gu"><a href="https://gujarati.webdunia.com" title="ગુજરાતી" languagecode="gu">ગુજરાતી</a></li>
          </ul>
        </li>

        {headerData.slice(0, 10).map((item, i) => (
          <li key={i}>
            <a href={item.DefaultUrl}>{item.Text}</a>

            {item.Items && item.Items.length > 0 && (
              <ul>
                {item.Items.map((sub, j) => (
                  <li key={j}>
                    <a href={sub.DefaultUrl}>{sub.Text}</a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}

      </ul>

    </div>
  </div>

  <div className="wd_sd_footer_menu">
    <ul>
      <li>
        <a href="/about-us">
          About Us
          <span><img src="/assets/img/svg/svgSpriteSheet.svg#user-id" alt="webdunia" /></span>
        </a>
      </li>
      <li>
        <a href="/disclaimer">
          Disclaimer
          <span><img src="/assets/img/svg/svgSpriteSheet.svg#discle" alt="webdunia" /></span>
        </a>
      </li>
      <li>
        <a href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en">
          Share the app
          <span><img src="/assets/img/svg/svgSpriteSheet.svg#share2" alt="webdunia" /></span>
        </a>
      </li>
      <li>
        <a href="/privacy-policy">
          Privacy Policy
          <span><img src="/assets/img/svg/svgSpriteSheet.svg#file" alt="webdunia" /></span>
        </a>
      </li>
      <li>
        <a href="/advertise-with-us">
          Advertise with us
          <span><img src="/assets/img/svg/svgSpriteSheet.svg#advert" alt="webdunia" /></span>
        </a>
      </li>
    </ul>
  </div>

</div>
      </>
    );
  }
}